import { getData, postData } from './Services';

export const getEstablishments = () => {
  let data = getData('/usuarios');
  return data;
};


export const getEstablishmentsByFilter = (filter, limit, page) => {
  let qs = `?page=${page}&limit=${limit}`;
  qs += filter ? '&name=' + filter : '';
  let data = getData('/usuarios/filter' + qs);
  return data;
};


export const postClientes = async (body) => {
    const res = await postData('/usuarios', body)
    return res
}
